import { MediaQueryBreakPoint, TypographyVariant } from '@execonline-inc/execonline-ui';

export const getTitleVariant = (breakPoint: MediaQueryBreakPoint): TypographyVariant => {
  switch (breakPoint) {
    case 'xl':
    case 'lg':
    case 'md':
    case 'sm':
      return 'h3';
    case 'xs':
      return 'h5';
  }
};
